// extracted by mini-css-extract-plugin
export default {"amount":"Invitations_amount__wfP2y"};